export const chatListData = [
  {
    id: 1,
    name: "William",
    status: "active",
    message: "Do you ever find yourself falling into the “discount trap?",
    photoUrl: "/assets/images/faces/4.jpg",
  },
  {
    id: 2,
    name: "Jhon Doe",
    status: "active",
    message: "Do you ever find yourself falling into the “discount trap?",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    id: 3,
    name: "Alex",
    status: "active",
    message: "Do you ever find yourself falling into the “discount trap?",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    id: 4,
    name: "Mathew Doe",
    status: "inactive",
    message: "Do you ever find yourself falling into the “discount trap?",
    photoUrl: "/assets/images/faces/1.jpg",
  },
  {
    id: 1,
    name: "Jessica Michel",
    status: "active",
    message: "Do you ever find yourself falling into the “discount trap?",
    photoUrl: "/assets/images/faces/4.jpg",
  },
  {
    id: 6,
    name: "Jhon Doe",
    status: "active",
    message: "Do you ever find yourself falling into the “discount trap?",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    id: 7,
    name: "Alex",
    status: "inactive",
    message: "Do you ever find yourself falling into the “discount trap?",
    photoUrl: "/assets/images/faces/3.jpg",
  },
  {
    id: 8,
    name: "Mathew Doe",
    status: "active",
    message: "Do you ever find yourself falling into the “discount trap?",
    photoUrl: "/assets/images/faces/1.jpg",
  },
  // {
  //   id: 9,
  //   name: "Jessica Michel",
  //   status: "active",
  //   message: "Do you ever find yourself falling into the “discount trap?",
  //   photoUrl: "/assets/images/faces/4.jpg",
  // },
  // {
  //   id: 10,
  //   name: "Jhon Doe",
  //   status: "active",
  //   message: "Do you ever find yourself falling into the “discount trap?",
  //   photoUrl: "/assets/images/faces/2.jpg",
  // },
  // {
  //   id: 11,
  //   name: "Alex",
  //   status: "inactive",
  //   message: "Do you ever find yourself falling into the “discount trap?",
  //   photoUrl: "/assets/images/faces/3.jpg",
  // },
];
